import { render, staticRenderFns } from "./MyListItemPrice.vue?vue&type=template&id=5a20abbe&"
import script from "./MyListItemPrice.vue?vue&type=script&lang=js&"
export * from "./MyListItemPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a20abbe')) {
      api.createRecord('5a20abbe', component.options)
    } else {
      api.reload('5a20abbe', component.options)
    }
    module.hot.accept("./MyListItemPrice.vue?vue&type=template&id=5a20abbe&", function () {
      api.rerender('5a20abbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/MyListItemPrice.vue"
export default component.exports